module.exports = __webpack_public_path__ + "static/media/cover press release (1).42ed232d.png";